<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog v-model="dialog" max-width="600" persistent>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>{{ $t('user_management.create_new_user') }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn dark icon @click="dialog = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-form ref="form">
          <v-subheader class="pl-0">{{ $t('user_management.user_type') }}</v-subheader>
          <v-switch
            v-model="localUser"
            :hint="$t('user_management.local_user_hint')"
            :label="$t('user_management.local_user')"
            class="mt-2 mb-4"
            color="primary"
            persistent-hint
          ></v-switch>

          <v-subheader class="pl-0">{{ $t('user_management.user_info') }}</v-subheader>
          <v-text-field
            v-if="localUser"
            v-model="username"
            :label="$t('user_management.username')"
            :rules="[$rules.required, $rules.spacesNotAllowed]"
            autocomplete="username"
            class="mt-0 username"
            type="text"
            validate-on-blur
          ></v-text-field>
          <v-text-field
            v-if="!localUser"
            v-model="username"
            :label="$t('user_management.email')"
            :rules="[$rules.required, $rules.email, $rules.spacesNotAllowed]"
            autocomplete="username"
            class="mt-0 email"
            type="text"
            validate-on-blur
          ></v-text-field>
          <v-text-field
            v-if="localUser"
            v-model="password"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            :label="$t('user_management.password')"
            :rules="[$rules.required]"
            :type="showPassword ? 'text' : 'password'"
            autocomplete="new-password"
            class="mt-0 password"
            validate-on-blur
            @click:append="showPassword = !showPassword"
          ></v-text-field>

          <v-subheader class="pl-0">{{ $t('user_management.user_roles') }}</v-subheader>
          <v-btn-toggle v-if="$vuetify.breakpoint.smAndUp" v-model="roleSet" class="elevation-0" mandatory multiple>
            <template v-for="role in roles">
              <v-btn :key="role" :color="$randomizeColorFromString(role, 60, 45)" :value="role" outlined text>{{
                  role
                }}
              </v-btn>
            </template>
          </v-btn-toggle>

          <v-select
            v-if="$vuetify.breakpoint.xsOnly"
            v-model="roleSet"
            :items="roles"
            :label="$t('user_management.roles')"
            attach
            chips
            multiple
            style="width: 100%"
          >
            <template v-slot:selection="data">
              <v-chip
                :color="$randomizeColorFromString(data.item, 60, 45)"
                :input-value="data.selected"
                class="ml-0"
                close
                outlined
                small
                @input="removeRole(data.item)"
              >
                <strong>{{ data.item }}</strong>
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-action>
                <v-icon v-if="roleSet.findIndex(r => r === data.item) > -1"
                        :color="$randomizeColorFromString(data.item, 60, 45)"
                >check_box
                </v-icon
                >
                <v-icon v-else :color="$randomizeColorFromString(data.item, 60, 45)">check_box_outline_blank</v-icon>
              </v-list-item-action>
              <v-list-item-title :style="{ color: $randomizeColorFromString(data.item, 60, 45) }">{{
                  data.item
                }}
              </v-list-item-title>
            </template>
          </v-select>
        </v-form>

        <v-alert :value="showAlert" class="mt-4" outlined type="error">{{ $t('check_all_required_fields') }}</v-alert>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions :class="$vuetify.breakpoint.xsOnly ? 'flex-column-reverse' : ''">
        <v-spacer></v-spacer>
        <v-btn :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.xsOnly" class="ma-1" color="default"
               @click="dialog = false">
          <v-icon left>close</v-icon>
          <span>{{ $t('cancel') }}</span>
        </v-btn>
        <v-btn :block="$vuetify.breakpoint.xsOnly" :large="$vuetify.breakpoint.xsOnly" class="ma-1" color="primary"
               @click="saveUser">
          <v-icon left>check</v-icon>
          <span>{{ $t('save') }}</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import adminApi from '../../api/admin';

export default {
  name: 'AddUserDialog',
  props: {
    roles: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dialog: false,
      localUser: false,
      username: '',
      password: '',
      showPassword: false,
      roleSet: this.roles.length > 0 ? [this.roles[0]] : [],
      showAlert: false,
    };
  },
  methods: {
    open() {
      this.dialog = true;
    },
    removeRole(item) {
      this.roleSet.splice(this.roleSet.indexOf(item), 1);
      this.roleSet = [...this.roleSet];
    },
    async saveUser() {
      if (!this.$refs.form.validate()) {
        this.showAlert = true;
        return;
      }

      let user = {
        roleSet: this.roleSet,
        username: this.username,
        email: this.username,
        type: this.type,
      };

      user.type = this.localUser ? 'LOCAL' : 'COGNITO';

      if (this.localUser) user.password = this.password;

      try {
        await adminApi.createUser(user);
        this.dialog = false;
        this.$showSuccessNotification(this.$t('user_management.user_created_success'));
      } catch (err) {
        this.$handleApiError(err);
      }
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.localUser = false;
        this.username = '';
        this.password = '';
        this.showPassword = false;
        this.roleSet = [];
        this.showAlert = false;
        this.$refs.form.reset();
        this.$emit('on-dismiss');
      }
    },
  },
};
</script>

<style scoped></style>
